import { render, staticRenderFns } from "./PresentLevelsWizardFilters.vue?vue&type=template&id=631a54e2&scoped=true"
import script from "./PresentLevelsWizardFilters.vue?vue&type=script&lang=js"
export * from "./PresentLevelsWizardFilters.vue?vue&type=script&lang=js"
import style0 from "./PresentLevelsWizardFilters.vue?vue&type=style&index=0&id=631a54e2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631a54e2",
  null
  
)

export default component.exports